var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-container"},[_c('router-view',{attrs:{"login":_vm.login}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }